"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaCategory = exports.ZodSpaceSettingsKeys = exports.WriteableSpaceSettingsSchema = exports.MAX_INFO_BOARD_ANNOUNCEMENTS_LENGTH = exports.eventLocationIsSpawnToken = exports.SpaceUserResourceFields = exports.SpaceUserPrismaResourceSelect = exports.SpaceUserResourceSelect = exports.MemberInfoDBFields = exports.remoteWorkOwnerRoles = exports.remoteWorkDeprecatingRoles = exports.eventsSurfacedRoles = exports.remoteWorkSurfacedRoles = exports.ANY_MEMBER_ROLE_RW = exports.GuestPassStatus = exports.CoreRoleEnumMigration = void 0;
const gameMap_1 = require("@gathertown/gather-game-common/dist/src/public/gameMap");
Object.defineProperty(exports, "AreaCategory", { enumerable: true, get: function () { return gameMap_1.AreaCategory; } });
const Player_1 = require("@gathertown/gather-game-common/dist/src/public/Player");
const zod = __importStar(require("zod"));
const ramda_1 = require("ramda");
var CoreRoleEnumMigration;
(function (CoreRoleEnumMigration) {
    CoreRoleEnumMigration["DEFAULT_BUILDER"] = "Builder";
    CoreRoleEnumMigration["DEFAULT_MOD"] = "Mod";
    CoreRoleEnumMigration["DEFAULT_OWNER"] = "Owner";
    CoreRoleEnumMigration["OWNER"] = "Owner";
    CoreRoleEnumMigration["DEFAULT_MEMBER"] = "GeneralMember";
    CoreRoleEnumMigration["GENERAL_MEMBER"] = "GeneralMember";
    CoreRoleEnumMigration["SPEAKER"] = "Speaker";
    CoreRoleEnumMigration["RECORDING_CLIENT"] = "RecordingClient";
    CoreRoleEnumMigration["GUEST"] = "Guest";
})(CoreRoleEnumMigration || (exports.CoreRoleEnumMigration = CoreRoleEnumMigration = {}));
var GuestPassStatus;
(function (GuestPassStatus) {
    GuestPassStatus["Admitted"] = "ADMITTED";
    GuestPassStatus["Revoked"] = "REVOKED";
    GuestPassStatus["Hidden"] = "HIDDEN";
})(GuestPassStatus || (exports.GuestPassStatus = GuestPassStatus = {}));
exports.ANY_MEMBER_ROLE_RW = [
    Player_1.CoreRole.GeneralMember,
    Player_1.CoreRole.Builder,
    Player_1.CoreRole.Mod,
    Player_1.CoreRole.Owner,
];
exports.remoteWorkSurfacedRoles = [Player_1.CoreRole.Owner, Player_1.CoreRole.Builder, Player_1.CoreRole.GeneralMember];
exports.eventsSurfacedRoles = [Player_1.CoreRole.Owner, Player_1.CoreRole.Mod, Player_1.CoreRole.Builder];
exports.remoteWorkDeprecatingRoles = {
    [Player_1.CoreRole.Mod]: "Mod",
};
exports.remoteWorkOwnerRoles = Object.keys(exports.remoteWorkSurfacedRoles)
    .filter((role) => !Object.keys(exports.remoteWorkDeprecatingRoles).includes(role))
    .map((role) => role);
const MemberInfoDBSelect = {
    becameMemberAt: true,
    city: true,
    connected: true,
    country: true,
    currentGuestUsageMinutes: true,
    currentlyEquippedWearables: true,
    description: true,
    deskInfo: true,
    guestPassStatus: true,
    handRaisedAt: true,
    hasAccess: true,
    id: true,
    spaceUserUuid: true,
    lastVisited: true,
    map: true,
    mobileLastActive: true,
    name: true,
    personalImageId: true,
    personalImageUrl: true,
    phone: true,
    profileImageId: true,
    profileImageUrl: true,
    pronouns: true,
    role: true,
    spaceId: true,
    startDate: true,
    timezone: true,
    title: true,
    x: true,
    y: true,
    spaceUserSetting: true,
};
exports.MemberInfoDBFields = Object.keys(MemberInfoDBSelect);
exports.SpaceUserResourceSelect = {
    city: true,
    country: true,
    currentlyEquippedWearables: true,
    description: true,
    deskInfo: true,
    email: true,
    guestPassStatus: true,
    hasAccess: true,
    id: true,
    lastVisited: true,
    map: true,
    name: true,
    personalImageId: true,
    personalImageUrl: true,
    phone: true,
    profileImageId: true,
    profileImageUrl: true,
    pronouns: true,
    role: true,
    startDate: true,
    timezone: true,
    title: true,
    userUuid: true,
    spaceUserUuid: true,
    currentGuestUsageMinutes: true,
};
exports.SpaceUserPrismaResourceSelect = {
    id: true,
    city: true,
    country: true,
    outfit: true,
    description: true,
    desk: true,
    inventory: true,
    guestPassStatus: true,
    guestPassExpiresAt: true,
    hasAccess: true,
    userFirestoreId: true,
    spaceFirestoreId: true,
    lastVisitedAt: true,
    mapFirestoreId: true,
    name: true,
    personalImageId: true,
    personalImageUrl: true,
    phone: true,
    profileImageId: true,
    profileImageUrl: true,
    pronouns: true,
    role: true,
    timezone: true,
    title: true,
};
exports.SpaceUserResourceFields = (0, ramda_1.keys)(exports.SpaceUserResourceSelect);
const eventLocationIsSpawnToken = (location) => !!location && typeof location !== "string" && location.hasOwnProperty("type");
exports.eventLocationIsSpawnToken = eventLocationIsSpawnToken;
exports.MAX_INFO_BOARD_ANNOUNCEMENTS_LENGTH = 5;
const ZodAnnouncementMap = zod.object({
    id: zod.string(),
    message: zod.string(),
    createdAt: zod.string(),
    updatedAt: zod.string(),
});
exports.WriteableSpaceSettingsSchema = zod.object({
    allowStaffAccess: zod.boolean().optional(),
    autoPromoteMembersEmailDomains: zod.array(zod.string()).optional().nullable(),
    autoPromoteMembersEnabled: zod.boolean().optional().nullable(),
    betaFeaturesEnabled: zod.array(zod.string()).optional(),
    disableChat: zod.boolean().optional(),
    disableChatPersist: zod.boolean().optional(),
    disableInvite: zod.boolean().optional(),
    disableScreenshare: zod.boolean().optional(),
    disableTutorial: zod.boolean().optional(),
    emailDomains: zod.array(zod.string()).optional(),
    enableRecordingForMembersV2: zod.boolean().optional(),
    gatherLabsFeaturesEnabled: zod.array(zod.string()).optional(),
    globalBuild: zod.boolean().optional(),
    guestCheckInEnabled: zod.boolean().optional(),
    preloadAllAssets: zod.boolean().optional(),
    requireLogin: zod.boolean().optional(),
});
const ReadableSpaceSettingsSchema = exports.WriteableSpaceSettingsSchema.merge(zod.object({
    forceMute: zod.boolean().optional(),
    informationBoard: zod
        .object({
        pinned: zod.array(ZodAnnouncementMap).optional(),
        announcements: zod.array(ZodAnnouncementMap).optional(),
    })
        .optional(),
    spaceWasRWHangoutOnCreation: zod.boolean().optional(),
}));
exports.ZodSpaceSettingsKeys = ReadableSpaceSettingsSchema.keyof();
//# sourceMappingURL=space.js.map